import React, { useState } from "react";
import { Button } from "react-bootstrap";
import StoresPreviewList from "./StoresPreviewList";
import { FORM_FIELDS } from "../../Constants";
import AddStoreModal from "./AddStoreModal";
import { globalServices, tenantService } from "../../../../Services";
import useFetcher from "../../../../Hooks/useFetcher";
import { convertToDecimalString } from "../../../../Helpers/DecimalNumberHelper";
import ResultModal from "../../../Common/ResultModal";

const Stores = ({ stepState, previousPage, nextPage, formData, resetData }) => {
  const { STORE_DATA, LOGIN_DATA } = FORM_FIELDS;

  const { data: postOffices } = useFetcher({
    fetcher: globalServices.getPostOffices,
  });

  const [stores, setStores] = useState(formData[STORE_DATA.name] || []);
  const [showAddStoreModal, setShowAddStoreModal] = useState(false);
  const [storeModalUpdateData, setStoreModalUpdateData] = useState(null);

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const handleClose = () => {
    setModal({ show: false });
  };

  const onNextPage = () => {
    nextPage({
      [STORE_DATA.name]: stores,
    });
    return;
    const uploadData = stores.map((storeData) => {
      const newStore = { ...storeData };
      if (storeData.id) {
        delete newStore.priceListId;
        delete newStore.hasPriceList;
        return { ...newStore };
      }

      newStore[STORE_DATA.POSTAL_NUMBER.name] =
        newStore[STORE_DATA.POSTAL_NUMBER.name].value;

      newStore[STORE_DATA.POS_DATA.name] = newStore[
        STORE_DATA.POS_DATA.name
      ].map((pos) => {
        delete pos.idTemp;
        return {
          ...pos,
          [STORE_DATA.POS_DATA.DEPOSIT.name]: parseFloat(
            convertToDecimalString(pos[STORE_DATA.POS_DATA.DEPOSIT.name])
          ),
        };
      });

      return newStore;
    });

    tenantService
      .putTenantPublicOnboadring({
        params: { oib: formData[LOGIN_DATA.name]?.[LOGIN_DATA.OIB.name] },
        body: { [STORE_DATA.name]: uploadData },
        bearer: formData[LOGIN_DATA.name]?.[LOGIN_DATA.BEARER_TOKEN.name],
      })
      .then((res) => {
        if (res?.data?.success) {
          resetData(res?.data?.message);
          return;
        }
        setModal({
          show: true,
          title: "Greška!",
          text: "Došlo je dogreške prilikom slanja podataka. Molimo obratite se korisničkoj podršci.",
          btnClass: "btn btn-primary",
        });
      })
      .catch(() => {
        setModal({
          show: true,
          title: "Greška!",
          text: "Došlo je dogreške prilikom slanja podataka. Molimo obratite se korisničkoj podršci.",
          btnClass: "btn btn-primary",
        });
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="d-flex justify-content-between align-items-center">
            <h4>Lista prodajnih mjesta</h4>
            <Button
              onClick={() => {
                setShowAddStoreModal(true);
              }}
            >
              Dodaj prodajno mjesto
            </Button>
          </div>
          <StoresPreviewList
            stores={stores}
            setStores={setStores}
            showUpdateModal={(data) => {
              setShowAddStoreModal(true);
              setStoreModalUpdateData(data);
            }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          {/*
          <button className="btn btn-outline-secondary" onClick={previousPage}>
            Natrag
          </button>
        */}
        </div>
        <div className="col-6 text-right">
          <button className="btn btn-primary" onClick={onNextPage}>
            Sljedeći korak
          </button>
        </div>
      </div>

      <AddStoreModal
        stores={stores}
        setStores={setStores}
        postOffices={postOffices}
        updateData={storeModalUpdateData}
        show={showAddStoreModal}
        onHide={() => {
          setShowAddStoreModal(false);
          setStoreModalUpdateData();
        }}
      />

      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        closeBtnText="Zatvori"
        handleClose={handleClose}
      />
    </>
  );
};

export default Stores;
